import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import {
  FilterActionsUnion,
  FilterActionTypes
} from '@core/actions/filter.actions';
import { Follow } from '@app/models/follow';
import {
  AuthActionsUnion,
  AuthActionTypes
} from '@app/modules/core/actions/auth.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State {
  advancedFilters: any[];
  articleGroupFilters: any[];
}

export const INITIAL_STATE: State = {
  advancedFilters: [],
  articleGroupFilters: []
};

export function reducer(
  state: State = INITIAL_STATE,
  action: FilterActionsUnion
) {
  switch (action.type) {
    case FilterActionTypes.AddAdvancedFilter:
      return {
        ...state,
        advancedFilters: [...state.advancedFilters, action.filter]
      };

    case FilterActionTypes.RemoveAdvancedFilter:
      return {
        ...state,
        advancedFilters: state.advancedFilters.filter(
          f => f.key !== action.filter.key
        )
      };

    case FilterActionTypes.AddFilterArticleGroup:
      return {
        ...state,
        articleGroupFilters: [...state.articleGroupFilters, action.dataFilter]
      };

    case FilterActionTypes.RemoveFilterArticleGroup:
      return {
        ...state,
        articleGroupFilters: state.articleGroupFilters.filter(
          x => x.key !== action.dataFilter.key
        )
      };
    // case FilterActionTypes.AddAdvancedFilterPro:
    //   return {
    //     ...state,
    //     advancedFilters: [...state.advancedFilters, action.filter]
    //   };

    // case MeActionTypes.SelectRole:
    //   return {
    //     ...state,
    //     user: { ...state.user, role: action.role },
    //     loggedIn: true
    //   };

    // case MeActionTypes.SelectCountry:
    //   return {
    //     ...state,
    //     user: { ...state.user, countryId: action.id },
    //     loggedIn: true
    //   };

    // case MeActionTypes.ResetRole:
    //   return INITIAL_STATE;

    default:
      return state;
  }
}

export const selectAdvancedFilters = (state: State) => state.advancedFilters;
export const selectArticleGroupFilter = (state: State) =>
  state.articleGroupFilters;
export const getState = createFeatureSelector<State>('filters');

export const getAdvancedFilters = createSelector(
  getState,
  selectAdvancedFilters
);

export const getArticleGroupFilters = createSelector(
  getState,
  selectArticleGroupFilter
);
